module.exports = __webpack_public_path__ + "fonts/CiscoSansTTThin.woff2";